import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ServiciosService } from '../../../services/servicios.service';

@Component({
  selector: 'app-circular-zero-twenty',
  templateUrl: './circular-zero-twenty.component.html',
  styleUrls: ['./circular-zero-twenty.component.scss']
})
export class CircularZeroTwentyComponent implements OnInit {
  public dtOptions:DataTables.Settings[];
  public totalServicios;
  public trigger:Subject<void>;
  public informe:string;
  constructor(public _servicios:ServiciosService) {
    this.dtOptions = [
      //Configuración de la tabla total servicios
      {
        columns:[
          {
            title:'CSC',
            data:'REQCSC'
          },
          {
            title:'cedula',
            data:'documento'
          },
          {
            title:'tipo',
            data:'tipo',
          },
          {
            title:'diagnostico',
            data:'diagnostico'
          },
          {
            title:'nombre',
            data:'nombre',
          },
          {
            title:'dia',
            data:'dia'
          }
        ]
      }
    ]
    this.trigger = new Subject();
  }

  ngOnInit() {
  }
  search(){
    this._servicios.serviciosHistorico().subscribe(servicios=>{
      this.totalServicios = servicios;
      this.trigger.next();
    })
  }
}
